/* eslint react/prop-types: 0 */
import React from 'react';
import { injectIntl } from 'react-intl';
import { IDENTITY } from '../../helpers/traceability/boardIdentity';
import './boardModals.scss';

/**
 * El camino de excepción: la placa tiene el firmware pero no tiene número grabado
 * en la EEPROM.
 *
 * Es el viejo paso de "leer datos", que antes venía antes de vincular y le tocaba
 * a todas las placas. Ahora aparece solo para las pocas que lo necesitan, y
 * después de vincular: la mayoría de las placas nunca lo ve.
 *
 * El botón existe porque WebUSB no abre su selector fuera de un gesto del
 * usuario. Todo lo que sigue -- leer, pedirle un número al servidor, grabarlo --
 * pasa con el modal abierto y sin botones: no hay nada que el usuario pueda
 * hacer mientras tanto, y cerrarlo antes de tiempo lo dejaría con la sensación de
 * que algo quedó a medias.
 */
const BoardIdentityModal = ({ state, intl, onRead }) => {
  const asking = state === IDENTITY.NEEDS_USB;
  const waiting = state === IDENTITY.READING_USB || state === IDENTITY.PROVISIONING;
  if (!asking && !waiting) return null;

  return (
    <>
      <div className="modal-backdrop show" />
      <div
        className="modal fade show boardIdentityModal short-modal"
        role="dialog"
        aria-modal="true"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {intl.formatMessage({ id: 'blocks.blockly.boardIdentity.title' })}
              </h5>
            </div>
            <div className="modal-body">
              {asking ? (
                <>
                  <img src="/images/web_serial/linking.png" width="72" alt="" />
                  <div className="instructions">
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.boardIdentity.messageLine1' }) }} />
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.boardIdentity.messageLine2' }) }} />
                    <div dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'blocks.blockly.boardIdentity.messageLine3' }) }} />
                  </div>
                </>
              ) : (
                <div className="waiting">
                  <div className="spinner" />
                  <p className="message">
                    {state === IDENTITY.READING_USB
                      ? intl.formatMessage({ id: 'blocks.blockly.boardIdentity.reading' })
                      : intl.formatMessage({ id: 'blocks.blockly.boardIdentity.preparing' })}
                  </p>
                </div>
              )}
            </div>
            {asking ? (
              <div className="modal-footer">
                <button type="button" className="btn btn-primary main-btn" onClick={onRead}>
                  {intl.formatMessage({ id: 'blocks.blockly.boardIdentity.buttons.read' })}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(BoardIdentityModal);
